<template>
  <!-- 订舱 -->
  <div class="Booking">
    <TopNavigation class="topNavigation"></TopNavigation>
    <div class="typeArea">
      <!-- 面包屑 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/Template' }">模板中心</el-breadcrumb-item>
        <el-breadcrumb-item class="bread">{{canshu.title}}模板</el-breadcrumb-item>
      </el-breadcrumb>

      <div class="mobanmingc">
        <div class="form-tit"><span>*</span>模板名称</div>
        <el-input v-model="form.template_name" placeholder="请输入"></el-input>
      </div>
      <div class="CargoInformation phone-info">
        <div class="title">基本信息</div>
        <div class="info">
          <i class="el-icon-info"></i>
          <span>*</span>号代表必填项
        </div>

        <div class="info-shang shanger">
          <div>
            <div class="word">
              <span>*</span>最终目的地/联系人/电话/联系邮箱
            </div>
            <el-input
              type="textarea"
              v-model="form.dest_address"
              placeholder="请输入内容"
            ></el-input>
          </div>
        </div>

        <div class="title qita">其他信息</div>
        <div class="info">
          <i class="el-icon-info"></i>
          <span>*</span>号代表必填项
        </div>

        <div class="info-shang">
          <div class="yi1">
            <div class="word">下单联系人</div>
            <el-input  v-model="form.order_username" placeholder="请输入内容"></el-input>
          </div>
          <div class="yi1">
            <div class="word">下单联系人电话</div>
            <el-input @blur="validDianhua" v-model="form.order_phone" placeholder="请输入内容"></el-input>
          </div>
          <div
            class="yi"
            v-for="(item, index) in emailList"
            :key="index"
            :class="(index + 3) % 4 == 0 ? 'yi2' : 'yi'"
          >
            <div class="word"><span>*</span>下单联系人邮箱</div>
            <div class="ipt_del">
              <el-input  @blur="validEmsil" v-model="item.email" placeholder="请输入"></el-input>
              <div @click="removeEmail(index)" class="delete">删除</div>
            </div>
          </div>
        </div>

        <div class="add" @click="addEmail">
          <i class="el-icon-circle-plus-outline"></i>
          <div>新增联系人邮箱</div>
        </div>
        <div class="info-shang">
          <div class="yi1">
            <div class="word"><span>*</span>船东</div>
            <el-select
              v-model="form.shipowner_id"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in shippingList"
                :key="item.id"
                :label="item.name_cn + '-' + item.name_en"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="yi1">
            <div class="word"><span>*</span>航名/航次</div>
            <el-input v-model="form.vessel_voyage" placeholder="请输入内容"></el-input>
          </div>
          <div class="yi1">
            <div class="word">销售代码</div>
            <el-input v-model="form.sales_code" placeholder="请输入内容"></el-input>
          </div>
        </div>
        <div class="info-shang">
          <div class="yi1">
            <div class="word"><span>*</span>提单类型</div>
            <div class="zhufen">
              <div @click="form.order_type = 1" :class="{ 'is-active': form.order_type == 1 }">
                主单
              </div>
              <div @click="form.order_type = 2" :class="{ 'is-active': form.order_type == 2 }">
                分单
              </div>
            </div>
          </div>
          <div class="yi1">
            <div class="word"><span>*</span>运输模式</div>
            <div class="moshi">
              <div @click="form.transport_mode = 1" :class="{ 'moshiis-active': form.transport_mode == 1 }">
                DAP
              </div>
              <div @click="form.transport_mode = 2" :class="{ 'moshiis-active': form.transport_mode == 2 }">
                DDU
              </div>
              <div @click="form.transport_mode = 3" :class="{ 'moshiis-active': form.transport_mode == 3 }">
                DDP
              </div>
            </div>
          </div>
          <div class="yi1">
            <div class="word"><span>*</span>主单提单号</div>
            <el-input v-model="form.mawb_blno" placeholder="请输入内容"></el-input>
          </div>
          <div>
            <div class="word">分单提单号</div>
            <el-input v-model="form.split_order_blno" placeholder="请输入内容"></el-input>
          </div>
        </div>
        <div class="info-shang">
          <div class="yi1">
            <div class="word"><span>*</span>分单目的港代理联系人信息</div>
            <el-input
              type="textarea"
              v-model="form.split_order_address"
              placeholder="请输入内容"
            ></el-input>
          </div>
          <div>
            <div class="word">订单备注</div>
            <el-input
              type="textarea"
              v-model="form.order_remarks"
              placeholder="请输入内容"
            ></el-input>
          </div>
        </div>

        <div class="button">
          <el-button class="quxiao" @click="$router.push('/Template')">取消</el-button>
          <el-button class="dingcanggg" @click="save">保存</el-button>
        </div>
      </div>
    </div>
    <Bottom />
  </div>
</template>
     
  <script>
import Bottom from "../HP/BottomPage.vue";
import TopNavigation from "../HP/TopNavigationB.vue";
import { baseShippingCompanyValidList,mjdmTemplateAdd,mjdmTemplateEdit,mjdmTemplateDetail } from "@/api/api";
export default {
  components: {
    Bottom,
    TopNavigation,
  },
  data() {
    return {
      num: 0,
      emailList: [{ email: "" }],
      shippingList: [],
      form:{
        template_name:'', // 模板名称
        dest_address:'', // 最终目的地地址/联系人/电话/邮箱
        order_type:'1', // 订单类型：1主单、2分单
        split_order_address:'', // 分单目的港联系人/电话/邮箱
        order_username:'', // 下单委托人
        order_phone:'', // 下单委托人电话
        vessel_voyage:'', // 船名/航次
        shipowner_id:'', // 船东ID
        mawb_blno:'', // 主单提单号
        split_order_blno:'', // 分单提单号
        transport_mode:'1', // 运输模式
        sales_code:'', // 销售代码
        order_remarks:'', // 订单备注
        email:[], // 下单委托人邮箱：['111','222']
      },
      headers: {
        token: localStorage.getItem("token"),
      },
      // 接收参数，
      canshu:{},
    };
  },
  methods: {
    addEmail() {
      this.emailList.push({ email: "" }); // 添加新行
    },
    removeEmail(index) {
      this.emailList.splice(index, 1); // 删除指定行
    },
    handleChange(value) {
      console.log(value);
    },
    // 船公司
    async getShippingList() {
      const res = await baseShippingCompanyValidList();
      if (res.code == 1) {
        this.shippingList = res.data;
      }
    },
    // 添加编辑
    async save(){
      let api = mjdmTemplateAdd
      if(this.canshu.title=='编辑'){
        api = mjdmTemplateEdit
      }
      this.form.email = []
      for (let i = 0; i < this.emailList.length; i++) {
        this.form.email.push(this.emailList[i].email)
      }

      try {
        const res = await api(this.form,this.headers)
        if(res.code==1){
          this.$message({
            type:'success',
            message:this.canshu.title=='编辑'?'修改成功':'保存成功'
          })
          this.$router.push('/Template')
        }else{
          this.$message({
            type:'error',
            message:res.msg
          })
        }
      } catch (error) {
        console.log(error,'失败');
      }
    },
    // 编辑时 根据id获取详情
    async getDetail(){
      try {
        const res = await mjdmTemplateDetail({
          id:this.canshu.id
        },this.headers)
        if (res.code==1) {
          this.form = res.data
          this.emailList=[]
          for (let i = 0; i < res.data.email.length; i++) {
              this.emailList.push({'email':res.data.email[i]})
          }
        }
      } catch (error) {
        console.log(error,'失败');
      }
    },
    // 校验邮箱
    validEmsil(e) {
      let emial = e.target.value
      if(emial==''){
        return
      }
      if (emial == "" || emial == undefined) {
        this.$message({
          message: "请输入邮箱地址",
          type: "error",
        });
        return false;
      } else if (
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
          emial
        )
      ) {
        this.$message({
          // duration:0,
          message: "请输入正确的邮箱地址",
          type: "error",
        });
        return false;
      }
      return true;
    },
    // 校验手机号
    validDianhua() {
      let dianhua = this.form.order_phone
      if(dianhua==''){
        return
      }
      if (!/^1[3-9]\d{9}$/.test(dianhua)) {
        // this.$toast('请输入正确的手机号')
        // alert('1121')
        // this.$message.error("请输入正确的手机号");
        this.$message({
          // duration:0,
          message: "请输入正确的手机号",
          type: "error",
        });
        return false;
      }
      return true;
    },
  },
  mounted(){
    this.canshu = this.$route.params
    if (this.canshu.title=='编辑') {
      this.getDetail()
    }
    this.getShippingList()
  }
};
</script>
  
  <style style lang="scss" scoped>
.topNavigation {
  height: 100PX;
  display: flex;
  justify-content: space-between;
  padding: 0 80px;
  // background: #Fff;
}

.Booking {
  background: #f9f9f9;
}
.mobancon {
  background: #fff;
  // background: pink;
  padding: 32px;
  box-sizing: border-box;
  margin-bottom: 24px;
  border-radius: 12px;
}
.typeArea {
  width: 1200px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.el-breadcrumb {
  margin: 20px 0;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  .el-breadcrumb__inner is-link {
    color: pink;
  }
}

:deep(.el-breadcrumb) {
  .el-breadcrumb__inner {
    color: #999999 !important;
  }
  .bread {
    span {
      color: #0073f5 !important;
    }
  }
}

.template {
  box-sizing: border-box;
  height: 122px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  padding: 32px;
  margin-bottom: 20px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  .left {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #999999;
    text-align: left;
    font-style: normal;
    text-transform: none;
    .shiyopng {
      color: #0073f5;
      font-size: 20px;
      margin-bottom: 8px;

      .wode {
        margin-left: 9px;
        display: inline-block;
        width: 80px;
        height: 28px;
        background: #edf6ff;
        border-radius: 4px 4px 4px 4px;

        font-size: 14px;

        text-align: center;
        line-height: 28px;
      }
    }
  }

  .right {
    height: 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;

    cursor: pointer;
  }
}

.CargoInformation {
  // height: 401px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;

  margin-bottom: 20px;
  padding: 32px;
  box-sizing: border-box;

  .info {
    font-size: 14px;
    color: #606260;
    margin-top: 10px;

    .el-icon-info {
      color: #ccc;
    }
    span {
      font-size: 14px;
      color: #fe3300;
    }
  }

  .title {
    width: 108px;
    height: 25px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .qita{
    margin-top: 32px;
  }
  .info-shang {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;

    .word {
      margin-bottom: 12px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      font-style: normal;
      text-transform: none;
      color: #606260;
      span {
        color: #fe3300;
      }
    }
    :deep(.el-input) {
      input {
        width: 266px;
        height: 44px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        border: 0;
      }
    }
    :deep(.el-textarea) {
      .el-textarea__inner {
        width: 556px;
        height: 160px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        border: 0;
      }
    }
  }
  .input {
    display: flex;
    flex-wrap: wrap;
    .yi {
      display: flex;
      // align-items: center;
      margin-right: 24px;
      margin-bottom: 20px;
    }

    .yi2 {
      display: flex;
      // align-items: center;
      margin-right: 24px;
      margin-right: 0px;
      margin-bottom: 20px;
    }

    .yiii {
      margin-right: 48px;
    }
    :deep(.el-input) {
      width: 242px;
      input {
        width: 242px;
        height: 44px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        border: 0;
      }
    }

    .el-icon-delete {
      color: #606260;
      margin-left: 8px;
      cursor: pointer;

      font-size: 16px;
      margin-top: 45px;
    }
  }

  .add {
    width: 120px;
    color: #0073f5;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #0073f5;
    font-style: normal;
    text-transform: none;

    cursor: pointer;

    display: flex;
    align-items: center;
    i {
      margin-right: 4px;
      font-size: 16px;
    }
  }

  .info-shoufat {
    :deep(.el-textarea) {
      .el-textarea__inner {
        width: 362px;
      }
    }
  }

  .zhufen {
    width: 266px;
    height: 44px;
    background: #f9f9f9;
    border-radius: 8px 8px 8px 8px;
    display: flex;
    align-items: center;
    padding: 6px;
    box-sizing: border-box;
    div {
      width: 120px;
      color: #999999;
      font-size: 14px;
      text-align: center;
      height: 32px;
      line-height: 32px;
      cursor: pointer;
    }
    .is-active {
      background: #0073f5;
      border-radius: 8px 8px 8px 8px;
      color: #fff;
    }
  }

  .moshi {
    width: 266px;
    height: 44px;
    background: #f9f9f9;
    border-radius: 8px 8px 8px 8px;
    display: flex;
    align-items: center;
    padding: 6px;
    box-sizing: border-box;
    div {
      width: 80px;
      color: #999999;
      font-size: 14px;
      text-align: center;
      height: 32px;
      line-height: 32px;
      cursor: pointer;
    }
    .moshiis-active {
      background: #0073f5;
      border-radius: 8px 8px 8px 8px;
      color: #fff;
    }
  }
}

.shoufat {
  height: 305px;
  :deep(.el-textarea) {
    .el-textarea__inner {
      width: 362px;
    }
  }
}

.phone-info {
  height: 100%;
  .info-shang {
    flex-wrap: wrap;
    justify-content: start;

    .yi1 {
      margin-right: 24px;
    }
    .yi {
      margin-bottom: 20px;
      margin-right: 24px;

      :deep(.el-input) {
        width: 226px;
        input {
          width: 226px;
          height: 44px;
          background: #f9f9f9;
          border-radius: 8px 8px 8px 8px;
          border: 0;
        }
      }
    }
    .yi2 {
      margin-right: 0px;
    }
    .delete {
      margin-right: 4px;
      font-size: 16px;

      cursor: pointer;

      font-size: 14px;
      color: #fe3300;

      line-height: 44px;
    }

    .ipt_del {
      display: flex;
      width: 266px;
      height: 44px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
    }
  }
  .add {
    width: 120px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #0073f5;
    font-style: normal;
    text-transform: none;

    cursor: pointer;

    display: flex;
    align-items: center;
  }

  .info_phone {
    .word {
      margin-top: 24px;
    }
    :deep(.el-textarea) {
      .el-textarea__inner {
        width: 1136px;
      }
    }
  }
}

.update {
  .title {
    margin-top: 24px;
    margin-bottom: 24px;
  }
  .shangchuan {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    font-style: normal;
    text-transform: none;
  }

  .btn {
    display: flex;
    margin-top: 12px;
    .sc_btn {
      width: 266px;
      height: 44px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
      color: #0073f5;
      font-size: 14px;
      border: 0;
    }
  }

  .upload-demo {
    width: 266px;
    margin-right: 24px;
  }

  .updateList {
    // margin-top: 12px;

    display: flex;
    align-items: baseline;

    i {
      font-size: 16px;
      color: #00b53c;
      margin-right: 9px;
    }

    .name {
      width: 130px;

      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #0073f5;
      font-style: normal;
      text-transform: none;
    }

    .el-butnm {
      color: #fe3300;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      font-style: normal;
      text-transform: none;

      height: 24px;
    }

    .del {
      color: #0073f5;
      margin-left: 53px;
    }
  }
}

.fukuan {
  // width: 1920px;
  height: 118px;
  background: #ffffff;

  .fk-content {
    height: 118px;

    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;

    .fk-left {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 14px;
      font-style: normal;
      text-transform: none;
      div {
        margin-top: 8px;
      }
      span {
        color: #fe3300;
      }
    }

    .fk-right {
      .fanhui {
        width: 100px;
        height: 40px;
        border-radius: 8px 8px 8px 8px;
        color: #999999;
        background: #f9f9f9;

        margin-left: 24px;
        border: 0;
        margin-right: 16px;
      }

      .tijiao {
        width: 100px;
        height: 40px;
        background: #0073f5;
        border-radius: 8px 8px 8px 8px;
        color: #fff;
        border: 0;
      }
    }
  }
}

.modelDetail {
  .detail {
    margin-top: 24px;
    .de-tit {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #999999;
      font-style: normal;
      text-transform: none;
    }

    .de-con {
      display: flex;
      flex-wrap: wrap;
      .conyi {
        width: 213px;
        height: 40px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        margin-right: 17px;
        margin-top: 12px;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #333333;
        font-style: normal;
        text-transform: none;

        div {
          // line-height: 40px;
          // padding-left: 12px;
          // padding-right: 12px;
          padding: 12px;
          width: 213px;

          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .coner {
        margin-right: 0px;
      }
    }

    .de-coner {
      justify-content: space-between;
      .conyi {
        margin-right: 0px;
      }
    }

    .de-consan {
      .conyi {
        width: 446px;
        height: 140px;

        padding: 12px;

        p {
          line-height: 16px;
          margin: 0;
        }
      }
    }

    .de-consi {
      .conyi {
        width: 290px;
        height: 140px;
      }
    }

    .de-conwu {
      .conyi {
        width: 910px;
        height: 140px;
      }
    }

    .con-up {
      display: flex;
      align-items: center;
      i {
        font-size: 16px;
        color: #00b53c;
        margin-right: 9px;
      }

      .name {
        width: 130px;

        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #333333;
        font-style: normal;
        text-transform: none;
      }

      .el-butnm {
        color: #0073f5;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        font-style: normal;
        text-transform: none;

        height: 18px;
        padding: 0;
      }
    }
  }
}

.el-drawer {
  .drawer-title {
    height: 92px;
    padding: 32px;

    display: flex;
    justify-content: space-between;
    border-bottom: #eee 1px solid;
    .word {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #333333;
      font-style: normal;
      text-transform: none;
      span {
        color: #999999;
        font-size: 14px;
        margin-left: 8px;
      }
    }

    i {
      font-size: 28px;
      color: #999;
      cursor: pointer;
    }
  }
  .tab-det {
    padding: 32px 32px 0 32px;
  }

  .tab-tit {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    font-style: normal;
    text-transform: none;

    margin-bottom: 20px;
  }

  .table {
    width: 100%;
    border-spacing: 0;

    border-bottom: solid 1px #eee;
    .theader {
      height: 48px;
      background: #f9f9f9;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #999999;
      font-style: normal;
      text-transform: none;
    }
    .first {
      padding-left: 24px;
      width: 320px;
    }
    .tbody {
      height: 68px;
      background: #fff;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      font-style: normal;
      text-transform: none;
    }
  }

  .drawer__footer {
    width: 100%;
    height: 80px;
    border-radius: 0px 0px 0px 0px;

    margin-top: 236px;

    display: flex;
    align-items: center;
    justify-content: flex-end;

    border-top: 1px #eee solid;
  }
}

.mobanmingc {
  height: 140px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  margin-bottom: 20px;
  padding: 32px;
  box-sizing: border-box;

  .form-tit {
    width: 92px;
    height: 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #606260;
    font-style: normal;
    text-transform: none;

    margin-bottom: 12px;

    span {
      color: #fe3300;
    }
  }
  :deep(.el-input) {
    width: 242px;
    input {
      width: 242px;
      height: 44px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
      border: 0;
    }
  }
}

.shanger {
  :deep(.el-textarea) {
    .el-textarea__inner {
      width: 558px;
      height: 160px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
      border: 0;
    }
  }
}

.button {
  text-align: center;
  margin-top: 48px;
  .quxiao {
    width: 100px;
    height: 40px;
    background: #f9f9f9;
    border-radius: 8px 8px 8px 8px;
    border: 0;
    color: #999999;
    font-size: 14px;
    margin-right: 16px;
  }

  .dingcanggg {
    width: 100px;
    height: 40px;
    background: #0073f5;
    border-radius: 8px 8px 8px 8px;
    color: #fff;
    border: 0;
    font-size: 14px;
    margin-right: 32px;
  }
}
</style>